/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState} from 'react'
import NavigationBar from '../components/NavBar'
import RentalVanTrackerComponent from '../components/RentalVanTrackerComponent'
import RentalClock from '../clock/rentalClock'
import _, { indexOf } from 'lodash';

var outsideBlockingClassName = 'visibleClassName'
var myDriver = null
var myCheckerFuckReactArray = []
var outsideDate = new Date()

var outsideBlockingClassName = 'visibleClassName'
var outsideCommentChecl = false
var myInterval

// eslint-disable-next-line no-extend-native
Date.prototype.getWeek = function () {
    var firstDate = new Date(this.getFullYear(), 0, 1)
    if (this.getFullYear() === 2021) {
        return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
    } else {
        return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
    }
}

const determineOffboarded = (offboradedContent, selectedFunctionDate) => {
    switch (offboradedContent) {
        case 'OffboardedForever':
            return false
        case 'Active':
            return true
        case 'verified':
            return true
        case null:
            return true        
        default:
            if (new Date(offboradedContent).getWeek() < new Date(selectedFunctionDate).getWeek()) {
                return false
            } else {
                return true
            }
    }
}

const RentalVanTracker = (props) => {
    useEffect( () => {
        if (props.superUser) {

        } else {
            async function postData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };
            async function putData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'PUT', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };
            postData('https://backendpajamas.herokuapp.com/tracker/', {
                ID: props.user_id
            }).then( response => {
                let theDate = new Date()
                let theTime = `${theDate.getHours()}:${theDate.getMinutes()}:${theDate.getSeconds()}`
                if (response.data) {
                    response.data.forEach( ele => {
                        if (ele.date === new Date().toDateString()) {
                            let localPagesList = [...ele.pages_list, `${ele.pages_list.length}+rentalvantracker+${theTime}`]
                            putData(`https://backendpajamas.herokuapp.com/trackeradditions/${ele._id}/`, {
                                pages_list: localPagesList
                            })
                        }
                    })
                }
            })
        }
    }, [])
    var CryptoJS = require("crypto-js");
    const [ mathSunday, setMathSunday ] = useState('14')
    const [ sunday, setSunday ] = useState(new Date())
    const [ otherDate, setOtherDate ] = useState(new Date())
    const [ driverData, setDriverData ] = useState([])
    const [ vehicleData, setVehicleData ] = useState([])
    const [ registrationSearch, setRegistrationSearch ] = useState([])
    const [ selectedDriver, setSelectedDriver ] = useState(null)
    const [ dataGate, setDataGate ] = useState(0)
    const [ topPart, setTopPart ] = useState([])
    const [ arrayChecked, setArrayChecked ] = useState([])
    const [ dateCheckArray, setDateCheckArray ] = useState([])
    const [ awesomeArrayArray, setAwesomeArrayArray ] = useState([])
    const [ singleUse, setSingleUse ] = useState(null)
    const [ deleteOption, setDeleteOption ] = useState(null)
    const [ driversArray, setDriversArray ] = useState([])
    const [ selectedCity, setSelectedCity ] = useState('DBS2')
    const [ madeArray, setMadeArray ] = useState([])
    const [ arrayToPickFrom, setArrayToPickFrom ] = useState([])
    const [ selectedName, setSelectedName ] = useState('Select Drivers')
    const [ selectedSunday, setSelectedSunday ] = useState('14')
    const [ searchTerm, setSearchTerm ] = useState('')
    const [ orderedVanDates, setOrderedVanDates ] = useState([])
    const [ lockScreen, setLockScreen ] = useState(null)
    const [ currentDate, setCurrentDate ] = useState(new Date())
    const [ changedSelection, setChangedSelection ] = useState(false)

    // button for locking the screen
    const [ lockBoolean, setLockBoolean ] = useState(false)
    const [ lockButton, setLockButton ] = useState(null)
    const [ blockingClassName, setBlockingClassName ] = useState('visibleClassName')
    const [ stopLoop, setStopLoop ] = useState(false)

    // station list
    const [ stationList, setStationList ] = useState([])

    useEffect( () => {
        if (props.station) {
            if (props.station.length > 0) {
                setSelectedCity(props.station[0])
            }
        }
    }, [])

    // change the outside date
    useEffect( () => {
        outsideDate = sunday
    }, [sunday])

    // handling the clock
    useEffect( () => {
        clearInterval(myInterval)
        const timeFunction = () => {
            let setTime = () => {
                setCurrentDate(new Date())
            }
            myInterval = setInterval( setTime, 1000)
        }
        timeFunction()
    }, [])

    useEffect( () => {
        setTimeout( () => {
            if (!lockBoolean && !stopLoop) {
                let newDate = new Date(outsideDate)
                let newFinalDate = newDate.setDate(newDate.getDate() + 9)
                if (currentDate > newFinalDate) {
                    handleMakeLockScreen()
                }
            }
        }, 1000)
    }, [currentDate])

    // make the the other date track sunday
    useEffect( () => {
        let today = new Date(sunday)
        setOtherDate(today)
    }, [sunday])

    // Locking the screen
    // makes it so that people cant click places and refresh the screen
    useEffect( () => {
        outsideBlockingClassName = blockingClassName
    }, [blockingClassName])
    
    // handle posting lock screen
    const handleMakeLockScreen = () => {
        setStopLoop(false)
        async function getDataNext(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
            return response ? response.json() : console.log('no reponse')
        };

        getDataNext('https://backendpajamas.herokuapp.com/rentallock/').then( response => {
            getDataNext('https://backendpajamas.herokuapp.com/rentalvanoverride/').then( responseOverride => {
                let overrideBool = false
                responseOverride.results.forEach( date => {
                    if ( new Date(date.date).toDateString() === new Date(outsideDate).toDateString()) {
                        overrideBool = true
                        setStopLoop(true)
                        setLockBoolean(false)
                    }
                })
                if (!overrideBool) {
                    async function postData(url = '', data = {}) {
                        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                        let originalText = bytes.toString(CryptoJS.enc.Utf8);
                        const response = await fetch(url, {
                            method: 'POST', 
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Token ${originalText}`
                            },
                            body: JSON.stringify(data)
                            });
            
                        return response ? response.json() : console.log('no reponse')
                    };
                    postData('https://backendpajamas.herokuapp.com/rentallock/', {
                        date: new Date(outsideDate).toDateString(),
                    }).then( response => {
                        setLockBoolean(true)
                    })
                }
            })
        })
        // async function postData(url = '', data = {}) {
        //     let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        //     let originalText = bytes.toString(CryptoJS.enc.Utf8);
        //     const response = await fetch(url, {
        //         method: 'POST', 
        //         mode: 'cors',
        //         cache: 'no-cache',
        //         credentials: 'same-origin',
        //         headers: {
        //             'Content-Type': 'application/json',
        //             'Authorization': `Token ${originalText}`
        //         },
        //         body: JSON.stringify(data)
        //         });

        //     return response ? response.json() : console.log('no reponse')
        // };

        // postData('https://backendpajamas.herokuapp.com/rentallock/', {
        //     date: otherDate.toDateString(),
        // }).then( response => {
        //     setLockBoolean(true)
        // })
    }

    const overrideLock = () => {
        async function getDataNext(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
            return response ? response.json() : console.log('no reponse')
        };
        async function deleteData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'DELETE', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
        };

        getDataNext('https://backendpajamas.herokuapp.com/rentallock/').then( response => {
            getDataNext('https://backendpajamas.herokuapp.com/rentalvanoverride/').then( responseOverride => {
                responseOverride.results.forEach( date => {
                    if ( new Date(date.date).toDateString() === new Date(outsideDate).toDateString()) {
                        deleteData(`https://backendpajamas.herokuapp.com/rentalvanoverride/${date.service_id}/`)
                    }
                })
                async function postData(url = '', data = {}) {
                    let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                    let originalText = bytes.toString(CryptoJS.enc.Utf8);
                    const response = await fetch(url, {
                        method: 'POST', 
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Token ${originalText}`
                        },
                        body: JSON.stringify(data)
                        });
        
                    return response ? response.json() : console.log('no reponse')
                };
                postData('https://backendpajamas.herokuapp.com/rentallock/', {
                    date: new Date(outsideDate).toDateString(),
                }).then( response => {
                    setLockBoolean(true)
                })
            })
        })
    }


    // handle unlocking
    const handleUnlock = () => {
        // handle unlocking
        setLockBoolean(false)
        async function getDataNext(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
            return response ? response.json() : console.log('no reponse')
        };
        async function deleteData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'DELETE', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
        };
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };

        postData('https://backendpajamas.herokuapp.com/rentalvanoverride/', {
            date: new Date(outsideDate).toDateString(),
        }).then( response => {
            setLockBoolean(false)
            console.log(response)
            postData('https://backendpajamas.herokuapp.com/eighthour/', {
                date: new Date(outsideDate).toDateString(),
                locktype: 'https://backendpajamas.herokuapp.com/rentalvanoverride/',
                lockid: response.service_id,
                current_date: new Date()
            })
        })

        getDataNext('https://backendpajamas.herokuapp.com/rentallock/').then( response => {
            response.results.forEach( date => {
                if ( date.date === new Date(sunday).toDateString()) {
                    deleteData(`https://backendpajamas.herokuapp.com/rentallock/${date.rental_id}/`)
                }
            })
        })
    }

    // make the lock button
    useEffect( () => {
        if (props.superUser || props.user_email === 'i.stoykov@h2ologistics.co.uk') {
            if (lockBoolean === false) {
                setLockButton(
                    <div 
                        className='rentalVanTrackerButton'
                        onClick={() => overrideLock()}
                    >
                        Lock Screen
                    </div>
                )
            } else {
                setLockButton(
                    <div 
                        className='rentalVanTrackerButton'
                        onClick={() => handleUnlock()}
                    >
                        Unlock Screen
                    </div>
                )
            }
        }
    }, [props, lockBoolean])

    // lock the screen
    useEffect( () => {
        setLockBoolean(false)
        async function getDataNext(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
            return response ? response.json() : console.log('no reponse')
        };

        getDataNext('https://backendpajamas.herokuapp.com/rentallock/').then( response => {
            response.results.forEach( date => {
                if ( date.date === otherDate.toDateString()) {
                    setLockBoolean(true)
                }
            })
        })
    }, [otherDate])

    // make the blank screen
    useEffect( () => {
        if (lockBoolean === true) {
            setLockScreen(
                <div className='lockTheRentalTracker'>

                </div>
            )
            if (!props.superUser && props.user_email !== 'i.stoykov@h2ologistics.co.uk') {
                setLockButton(
                    <>
                        <h3 className='errrgherghegrher'>Screen Locked by Manager</h3>
                    </>
                )
            }
        } else {
            setLockScreen(null)
            if (!props.superUser && props.user_email !== 'i.stoykov@h2ologistics.co.uk') {
                setLockButton(
                    <>
                    </>
                )
            }
        }
    }, [lockBoolean, otherDate])

    // make a sunday
    useEffect( () => {
        let myDate = new Date()
        while (myDate.getDay() > 0) {
            myDate.setDate(myDate.getDate() - 1)
        }
        setSunday(myDate)
        setMathSunday(myDate.toDateString())
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });

            return response ? response.json() : console.log('no reponse')

        };
        getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
            setDriverData(response.results)
            setDriversArray(response.results)
        })
        getData('https://backendpajamas.herokuapp.com/vehicles/').then( response => {
            setVehicleData(response.results)
        })
    }, [])

    //////// function for data
    useEffect(() => {
        let localSunday = new Date(sunday)
        while (localSunday.getDay() > 0) {
            localSunday.setDate(localSunday.getDate() - 1)
        }
        if (localSunday.getDay() === 0) {
            async function postData(url = '', data = {}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                    });
    
                return response ? response.json() : console.log('no reponse')
            };

            postData('https://backendpajamas.herokuapp.com/vandatesordered/', {
                date: localSunday.toDateString(),
                week: localSunday.getWeek()
            }).then( (response) => {
                setOrderedVanDates(response.data)
            })
        } 
    }, [sunday, dataGate])

    /////////////////
    // function for resetting the drivers
    const reloadDrivers = () => {
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });

            return response ? response.json() : console.log('no reponse')

        };

        getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
            setDriverData(response.results)
        })
    }


     /////////////////
    // function for resetting the dates
    const reloadDates = (localTheDate) => {
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };

        postData('https://backendpajamas.herokuapp.com/vandatesordered/', {
            date: localTheDate,
            week: new Date(localTheDate).getWeek()
        }).then( (response) => {
            setOrderedVanDates(response.data)
        })
    }

    // sets the variable outside for use in posting
    useEffect( () => {
        myDriver = selectedDriver
    }, [selectedDriver])

    useEffect( () => {
        myCheckerFuckReactArray = []
    }, [sunday])

    // function for adding name to the rental van tracker
    const handleNameClick = (e, theDriver) => {
        setSelectedName(theDriver.name)
        async function putData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')

        };
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        if (theDriver.SigningUrlNumber === 'rentalVanTracked') {
            let localArray = [...theDriver.rentalCheckList]
            let localFinalArray = []
            if (sunday) {
                localArray.forEach( ele => {
                    if (ele !== new Date(sunday).toDateString()) {
                        localFinalArray.push(ele)
                    }
                })
            }
            putData(`https://backendpajamas.herokuapp.com/drivers/${theDriver.driver_id}/`, {
                rentalCheckList: localFinalArray
            }).then( (response) => {
                reloadDrivers()
            })
        } else {
            putData(`https://backendpajamas.herokuapp.com/drivers/${theDriver.driver_id}/`, {
                SigningUrlNumber: 'rentalVanTracked'
            }).then( (response) => {
                reloadDrivers()
            })
        }
    }

    // make the array of drivers to pick from
    useEffect( () => {
        let localArray = []
        driverData.sort( (a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
        // let aDate = new Date(sunday)
        driverData.forEach( ele => {
            // if (ele.name === 'Dumbeldore') {
            //     console.log()
            //     console.log(ele)
            // }
            if (ele.location === selectedCity && determineOffboarded(ele.status, sunday) && ele.name.toLowerCase().includes(searchTerm.toLowerCase())) {
                if (ele.SigningUrlNumber === null || ele.rentalCheckList.includes(new Date(sunday).toDateString())) {
                    localArray.push(
                        <li className="menu-item" id="makeMeWhite" onClick={(e, element) => handleNameClick(e, ele)}><a id="makeMeWhiteli" href="#0">{ele.name}</a></li>
                    )
                }
            }
        }) 
        setArrayToPickFrom(localArray)
    }, [driverData, selectedCity, searchTerm, sunday])

    // sets the variable outside for use in posting
    useEffect( () => {
        myCheckerFuckReactArray = awesomeArrayArray 
    }, [awesomeArrayArray])

    // set city
    const handleSelectSunday = (e, city) => {
        setSunday(city)
    }

    useEffect( () => {
        let myDate = new Date()
        while (myDate.getDay() > 0) {
            myDate.setDate(myDate.getDate() - 1)
        }
        let localSunday = new Date(sunday)
        let first = new Date(localSunday.setDate(localSunday.getDate())).toDateString()
        let second =  new Date(localSunday.setDate(localSunday.getDate() + 1)).toDateString()
        let third = new Date(localSunday.setDate(localSunday.getDate() + 1)).toDateString()
        let fourth = new Date(localSunday.setDate(localSunday.getDate() + 1)).toDateString()
        let fifth = new Date(localSunday.setDate(localSunday.getDate() + 1)).toDateString()
        let sixth = new Date(localSunday.setDate(localSunday.getDate() + 1)).toDateString()
        let seventh = new Date(localSunday.setDate(localSunday.getDate() + 1)).toDateString()
        let localArray = []
        localArray.push(
            <div className='van_Horizontal'>
                <div className='van_vertical'>
                    DA Name
                </div>
                <div className='van_vertical_weekday'>
                    Van Reg
                </div>
                <div className='van_vertical_weekday'>
                    {new Date(first).toLocaleDateString('en-GB')}
                </div>
                <div className='van_vertical_weekday'>
                    {new Date(second).toLocaleDateString('en-GB')}
                </div>
                <div className='van_vertical_weekday'>
                    {new Date(third).toLocaleDateString('en-GB')}
                </div>
                <div className='van_vertical_weekday'>
                    {new Date(fourth).toLocaleDateString('en-GB')}
                </div>
                <div className='van_vertical_weekday'>
                    {new Date(fifth).toLocaleDateString('en-GB')}
                </div>
                <div className='van_vertical_weekday'>
                    {new Date(sixth).toLocaleDateString('en-GB')}
                </div>
                <div className='van_vertical_weekday'>
                    {new Date(seventh).toLocaleDateString('en-GB')}
                </div>
                <div className='van_vertical_weekday'>
                    Total
                </div>
            </div>
        )
        let myDateArray = [
            first,
            second, 
            third, 
            fourth, 
            fifth, 
            sixth, 
            seventh
        ]
        setDateCheckArray(myDateArray)
        setTopPart(localArray)
    }, [sunday])

    // return
    const handleReturn = () => {
        setDeleteOption(null)
    }

    // delete van rental day
    const handleDeleteDay = (e, targetDate, currentDate, dateId, dayDetails, driverDetails) => {
        setDeleteOption(
            <div className='makeMeBig'> 
                <div className='deletionObjectionTwo'>
                    would you like to remove this day?
                    <div>
                        <button className='deleteButton' onClick={(e, someStuff) => actuallyDelete(e, targetDate, currentDate, dateId, dayDetails, driverDetails)}>Delete</button> 
                        <button className='returnButton' onClick={handleReturn}>Return</button> 
                    </div>
                </div>
            </div>
        )
    }

    // actually delete

    const actuallyDelete = (e, targetDate, currentDate, dateId, dayDetails, driverDetails) => {
        // send form to backend
        const handleSubmit = (theDate) => {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            async function DeleteData(url = '') {
                const response = await fetch(url, {
                    method: 'DELETE', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    });

                return response ? response : console.log('no reponse')

            };

            async function postData(url='', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : {'error': 'no response'}
            }
            postData(`https://backendpajamas.herokuapp.com/deletedData/`, {
                date: new Date(),
                manager_id: props.user_id,
                deletion_info: [driverDetails.name, dayDetails.date, dayDetails.location, dayDetails.registration]
            }).then( response => {
                DeleteData(`https://backendpajamas.herokuapp.com/vanDates/${dateId}/`).then( (response) => {
                    reloadDates(currentDate)
                    setTimeout( () => {
                        setDeleteOption(null)
                    }, 100)
                })
            })
        }
        handleSubmit(targetDate)
    }

    // submit removal to backend
    const actuallyDeleteDriver = (e, theDriver) => {
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')

        };

        postData(`https://backendpajamas.herokuapp.com/drivers/${theDriver.driver_id}/`, {
            SigningUrlNumber: null
        }).then( (response) => {
            setRegistrationSearch([])
            let myGate = dataGate
            let theGate = myGate += 1
            setDataGate(theGate)
            setDeleteOption(null)
        })
    }

    // remove from list
    const handleRemove = (e, theDriver) => {
        setDeleteOption(
            <div className='makeMeBig'> 
                <div className='deletionObjectionTwo'>
                    would you like to remove {theDriver.name}?
                    <div>
                        <button className='deleteButton' onClick={(e, someStuff) => actuallyDeleteDriver(e, theDriver)}>Delete</button> 
                        <button className='returnButton' onClick={handleReturn}>Return</button> 
                    </div>
                </div>
            </div>
        )
    }

    // function for changing the city from dropdown
    const handleSelectCity = (e, selectCity) => {
        setSelectedCity(selectCity)
    }

    // get sundays
    const getSundays = () => {
        let sundays = []
        let currentDate = new Date(mathSunday)
        for (let i = -70; i < 50; i++) {
            let dateInner = new Date(currentDate.getFullYear(), currentDate.getMonth(), i)
            if (dateInner.getDay() === 0) {
                sundays.push(
                    <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectSunday(e, `${dateInner.toDateString()}`, `${dateInner.toDateString()}`)}><a href="#0" id="makeMeWhiteli">{dateInner.toLocaleDateString('en-GB')} | Week: {dateInner.getWeek()}</a></li>
                )
            }
        }
        return sundays
    }

    // dropdown menu options
    const optionsThree = getSundays()

    // set the search box with the content
    const handleSetSearchTerms = (e) => {
        setSearchTerm(e.target.value)
    }

    const returnTheOption = () => {
        let localArray = []
        stationList.forEach( ele => {
            localArray.push(
                <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, ele)}><a id="makeMeWhiteli" href="#0">{ele}</a></li>
            )
        })
        return localArray
    }
    
    useEffect( () => {
        if (props.superUser) {
            setStationList([
                'DBS2',
                'DXP1',
                'DSN1',
                'DCF1',
                'DEX2'
            ])
        } else {
            setStationList(props.station)
        }
    }, [props])

    return (
        <>
        {lockScreen}
        {deleteOption}
            <div className='home_content_rental_van_tracker' >
                <NavigationBar title='Rental Van Tracker' superUser={props.superUser ? true : false} email={props.user_email}/>
                <div className='main_content_rental_van_tracker'>
                <div className='clockContainer'>
                    <RentalClock 
                        currentDate={currentDate}
                        selectedDate={sunday}
                        changedSelection={changedSelection}
                    />
                </div>
                    <div className='topPartRentalVanTracker'>
                        <div className='drop_down_bar_container_rentalVanTracker'>
                            <nav class="menu">
                                <ol>
                                    <li className="menu-item" id="makeMeWhite" ><a href="#0" id="makeMeWhite">{selectedCity}</a>
                                        <ol className="sub-menu" id='makeThisMenuVisible'>
                                            {/* <li className="menu-item" onClick={(e, city) => handleSelectCity(e, 'DBS2')}><a href="#0">DBS2</a></li>
                                            <li className="menu-item" onClick={(e, city) => handleSelectCity(e, 'DSN1')}><a href="#0">DSN1</a></li>
                                            <li className="menu-item" onClick={(e, city) => handleSelectCity(e, 'DEX2')}><a href="#0">DEX2</a></li>
                                            <li className="menu-item" onClick={(e, city) => handleSelectCity(e, 'DXP1')}><a href="#0">DXP1</a></li>
                                            <li className="menu-item" onClick={(e, city) => handleSelectCity(e, 'DCF1')}><a href="#0">DCF1</a></li> */}
                                            {returnTheOption()}
                                        </ol>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className='drop_down_bar_container_rentalVanTracker'>
                            <nav class="menu">
                                <ol >
                                    <li className="menu-item" id="makeMeWhite"><a href="#0" id="makeMeWhite"><input value={searchTerm} onChange={handleSetSearchTerms} id='seachTermBoxRentalVanTracker'/></a>
                                        <ol className="sub-menu" id="makeMeWhite">
                                            {arrayToPickFrom}
                                        </ol>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className='drop_down_bar_container_rentalVanTracker' id='allowThis'>
                            <nav className="menu" >
                                <ol >
                                    <li className="menu-item" id="makeMeWhite" ><a href="#0" id="makeMeWhite">{new Date(sunday).toLocaleDateString('en-GB')}</a>
                                        <ol className="sub-menu" id="limitHeight">
                                            {optionsThree}
                                        </ol>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        {lockButton}
                    </div>
                    <div className='van_rental_tracker_overall'>
                        {topPart}
                        <RentalVanTrackerComponent 
                            dates={orderedVanDates}
                            drivers={driverData}
                            dateArray={dateCheckArray}
                            vehicleData={vehicleData}
                            selectedCity={selectedCity}
                            reloadTheDrivers={reloadDrivers}
                            currentDate={new Date(sunday).toDateString()}
                            reloadDatesProp={reloadDates}
                            handleDeleteDayProp={handleDeleteDay}
                            sunday={sunday}
                            userId={props.user_id}
                        />
                    </div>
                </div>
            </div >
        </>
    )
}

export default RentalVanTracker
